import { render, staticRenderFns } from "./custom-list-item-btn.component.vue?vue&type=template&id=28e0073c&scoped=true"
import script from "./custom-list-item-btn.component.ts?vue&type=script&lang=ts&external"
export * from "./custom-list-item-btn.component.ts?vue&type=script&lang=ts&external"
import style0 from "./custom-list-item-btn.component.vue?vue&type=style&index=0&id=28e0073c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28e0073c",
  null
  
)

export default component.exports